import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MobileCityPicker from '@/components/mobile/MobileCityPicker';
import CitySearchOptions from '@/components/form/CitySearchOptions';
import {
  CascadeOption,
  Option,
} from '@/components/form/cascade-select/CascadeSelect';
import { NATION_WIDE } from '@/constants/city';

const CitySearch = (props: {
  existCities: CascadeOption[];
  cityValue: Option | undefined;
  onSearch: (value: Option) => void;
  borderColor?: string;
  inputClassName?: string;
}) => {
  const {
    existCities,
    cityValue,
    onSearch,
    borderColor = 'border border-web-grey-50',
    inputClassName = '!bg-white !h-12 pl-5 pr-3 w-64',
  } = props;
  const [cityPickerOpen, setCityPickerOpen] = React.useState(false);

  const handleMobileSearch = () => setCityPickerOpen(true);

  const handleClick = (selectValue: Option) => {
    const { pinyin, id } = selectValue;
    if (pinyin || id === NATION_WIDE.id) {
      onSearch(selectValue);
    }
  };

  return (
    <>
      <CitySearchOptions
        options={existCities}
        value={cityValue}
        onChange={handleClick}
        handleMobileSearch={handleMobileSearch}
        isHalfWidth={true}
        arrowIcon={<ExpandMoreIcon />}
        inputClassName={`rounded-lg ${inputClassName} ${borderColor}`}
      />
      <MobileCityPicker
        value={cityValue}
        options={existCities}
        cityPickerOpen={cityPickerOpen}
        onCitySelect={handleClick}
        onClose={() => setCityPickerOpen(false)}
        showNationWide={false}
      />
    </>
  );
};

export default CitySearch;
